import { render, staticRenderFns } from "./UploadSingleDocument.vue?vue&type=template&id=3a136f74&scoped=true"
import script from "./UploadSingleDocument.vue?vue&type=script&lang=js"
export * from "./UploadSingleDocument.vue?vue&type=script&lang=js"
import style0 from "./UploadSingleDocument.vue?vue&type=style&index=0&id=3a136f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a136f74",
  null
  
)

export default component.exports